import { render, staticRenderFns } from "./SectionTechs.vue?vue&type=template&id=22e02272&scoped=true"
import script from "./SectionTechs.vue?vue&type=script&lang=ts"
export * from "./SectionTechs.vue?vue&type=script&lang=ts"
import style0 from "./SectionTechs.vue?vue&type=style&index=0&id=22e02272&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e02272",
  null
  
)

export default component.exports